export default __webpack_public_path__ + "static/media/MobileImg_dark.3395bcf4.svg";